import { AnalysisMethod } from '@/api/domains/analyses/types';

export const getMethodInfo = (method: AnalysisMethod) => {
  const info = {
    VECTOR_ONLY: { icon: 'pi-bolt', title: 'Quick Scan', duration: '~30s' },
    HYBRID: { icon: 'pi-sitemap', title: 'Smart Analysis', duration: '~3m' },
    RAG_ENHANCED: {
      icon: 'pi-star-fill',
      title: 'Deep Dive',
      duration: '~10m'
    }
  };
  return info[method] || info.HYBRID;
};
